module.exports = __webpack_public_path__ + "img/module-wiki.ea741e7b.svg";